import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useHistoryLocationBumi = () => {
  const location = useLocation()
  const bumi: boolean = useMemo(() => location?.state?.bumi || false, [location?.state?.bumi])

  return {
    comesFromPageBumi: bumi
  }
}